import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {ObservableBackendService} from "./observableBackend.service";
import {URLSearchParams} from "@angular/http";
import {ProcedureType} from "../domain/procedureType";
import {Vehicle} from "../domain/vehicle";
import {Procedure} from "../domain/procedure";
import {Page} from "../domain/page";
import {ExpirationType} from "../domain/expirationType";

@Injectable()
export class ProcedureService {

    constructor(private backendService: ObservableBackendService) {
    }

    public findProcedure(filter: Vehicle, page: number, itemsPerPage: number): Observable<Page> {
        let params = new URLSearchParams();
        if (filter.patent) {
            params.set('patent', filter.patent);
        }
        if (filter.contract.bank && filter.contract.bank.id) {
            params.set('contract.bank.id', filter.contract.bank.id);
        }
        if (filter.contract.contractNumber) {
            params.set('contract.contractNumber', filter.contract.contractNumber);
        }
        if (filter.contract.cuit) {
            params.set('contract.cuit', filter.contract.cuit);
        }
        if (filter.procedures.length > 0 && filter.procedures[0].id) {
            params.set('procedures[0].type.id', filter.procedures[0].type.id);
        }
        params.set('length', String(itemsPerPage));
        params.set('pageNumber', String(page));
        return this.backendService.get("procedures", params);
    }

    public findPendingProcedure(filter: Vehicle, page: number, itemsPerPage: number): Observable<Page> {
        let params = new URLSearchParams();
        if (filter.contract.bank && filter.contract.bank.id) {
            params.set('contract.bank.id', filter.contract.bank.id);
        }
        if (filter.contract.contractNumber) {
            params.set('contract.contractNumber', filter.contract.contractNumber);
        }
        if (filter.contract.cuit) {
            params.set('contract.cuit', filter.contract.cuit);
        }
        if (filter.procedures.length > 0 && filter.procedures[0].id) {
            params.set('procedures[0].type.id', filter.procedures[0].type.id);
        }
        params.set('length', String(itemsPerPage));
        params.set('pageNumber', String(page));
        return this.backendService.get("pendingProcedures", params);
    }

    public getVehicle(vehicleId: string): Observable<Vehicle> {
        return this.backendService.get("vehicle/" + vehicleId + "/procedure", null);
    }

    public get(procedureId: string): Observable<Procedure> {
        return this.backendService.get("procedure/" + procedureId, null);
    }

    public save(vehicle: Vehicle): Observable<Vehicle> {
        return this.backendService.post("vehicle/procedure", vehicle, null);
    }

    public delete(procedureId: string): Observable<Procedure> {
        return this.backendService.delete("procedure/" + procedureId, null, null);
    }

    public static getURLProcedureBulkload(documentId: string): string {
        return "/proceduresBulkloadDocument/" + documentId;
    }

    private static setParams(filter: Vehicle, page: number, itemsPerPage: number, withDocuments?: boolean): URLSearchParams {
        let params = new URLSearchParams();
        if (filter.patent) {
            params.set('patent', filter.patent);
        }
        if (filter.contract.bank && filter.contract.bank.id) {
            params.set('contract.bank.id', filter.contract.bank.id);
        }
        if (filter.contract.contractNumber) {
            params.set('contract.contractNumber', filter.contract.contractNumber);
        }
        if (filter.contract.cuit) {
            params.set('contract.cuit', filter.contract.cuit);
        }
        params.set('length', String(itemsPerPage));
        params.set('pageNumber', String(page));

        /*Opcional: descarga de documentos*/
        params.set('withDocuments', String(withDocuments));
        return params;
    }

    public static getURLFilterProcedures(filter: Vehicle, page: number, itemsPerPage: number, withDocuments: boolean): string {
        return "/proceduresReport?" + ProcedureService.setParams(filter, page, itemsPerPage, withDocuments).toString();
    }

    public getProcedureType(name: string): Observable<ProcedureType> {
        let params = new URLSearchParams();
        params.set('name', name);
        return this.backendService.get("procedureType", params);
    }

    public getExpirationTypes(): Observable<ExpirationType[]> {
        return this.backendService.get("expirationTypes", null);
    }

    public generateProcedureTempId(): Observable<any> {
        return this.backendService.get("procedure/generateTempId", null);
    }

    public deleteTempProcedureDocument(procedureId: string): Observable<boolean> {
        return this.backendService.delete("procedure/" + procedureId + "/documentTemp", null, null);
    }

    public getProcedureTypes(): Observable<any> {
        return this.backendService.get("procedureTypes", null);
    }

    public getContract(procedureId: string): Observable<any> {
        return this.backendService.get("procedure/" + procedureId, null);
    }

    public setVehicleId(vehicleId: string, procedureId: string): Observable<Vehicle> {
        return this.backendService.get("procedure/setVehicle/" + vehicleId + "/" + procedureId, null);
    }

    public updateProcedure(procedure: Procedure): Observable<Procedure> {
        return this.backendService.post("procedure/updateProcedure", procedure, null);
    }

    public sendMail(procedure: Procedure): Observable<Procedure> {
        return this.backendService.post("procedure/sendMail", procedure, null);
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/service/procedure.service.ts
 **/